import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async ({
    filter = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.config.getCateList, { filter }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
